/**
 * @module worker/worker
 */
import array from './array.js'
import { register, unregister } from './uid.js'

const store = new WeakMap()
const uids = new Map()

/**
 * Releases the instance for the provided request uid
 * @param {Object} instance
 * @param {string} uid
 */
export const release = (
  instance,
  uid
) => {
  const { prototype } = instance
  const { constructor } = prototype
  const instances = store.get(constructor)
  const reserved = uids.get(instance)
  
  reserved.delete(uid)
  
  if (!reserved.size) {
    const { url } = instance
    
    instance.close()
    instances?.delete(url)
    uids.delete(instance)
    unregister(instance, uid)
  }
}

/**
 * Registers a request for the provided constructor
 * @param {Function} constructor
 * @param {string} url
 * @param {object} options
 * @return {sse}
 */
export default (
  constructor,
  url,
  ...rest
) => {
  if (!store.has(constructor)) {
    store.set(constructor, new Map())
  }
  
  const instances = store.get(constructor)
  
  if (!instances.has(url)) {
    const instance = new constructor(url, ...rest)
    
    instances.set(url, instance)
    uids.set(instance, new Set())
  }
  
  const instance = instances.get(url)
  const uid = register(instance)
  
  uids.get(instance).add(uid)
  
  return array([uid, instance])
}
